export const DETAILS_PAGE_URL_DISCRIMINATOR_PARAM = 'd';

export const COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
export const MAINTENANCE_MODE_UNLOCKED_STORAGE_KEY =
  'maintenance-mode-unlocked';

export const PAGINATION_SIZES = [12, 25, 50, 100];
export const PAGINATION_SIZES_DETAIL_PAGE = [12, 25, 50, 100, 250];

export const DEFAULT_PAGE_SIZE = 12;
export const DEFAULT_FULLSCREEN_PAGE_SIZE = 50;
export const DEFAULT_GROUP_TABLE_PAGE_SIZE = 250;
export const DEFAULT_VEGA_CHART_PAGE_SIZE = 100_000;

export const TRANSIENT_WORKFLOW_STATE_POLLING_INTERVAL = 5000;

export const CUSTOM_FILTER_INSTANCE_ID_SUFFIX = '-custom';

export const GLOBAL_FILTER_URL_PARAM_PREFIX = 'gf_';

/** URL search param for table global text search; matches inbound preset in `usePresetPageFilters`. */
export const GLOBAL_SEARCH_URL_PARAM = 'global_search';

/** URL search param carrying comma-separated entity IDs for comparison detail pages. */
export const COMPARISON_ENTITIES_URL_PARAM = 'dp_entities';

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  NETWORK_ERROR: 0, // Used for network failures
} as const;
